<div class="image-container" [ngStyle]="containerStyles">
    <div class="image-overlay" [ngStyle]="overlayStyles" (mousemove)="onMouseMove($event)"></div>
    <img
      class="image-zoomed"
      #imageElement
      [src]="image.source"
      [ngStyle]="imageStyles"
    />
</div>